import { defineMessages } from 'react-intl';

export default defineMessages({
  pageTitle: {
    id: 'features.userRegistration.pageTitle',
    defaultMessage: 'Tipologia utente',
    description: 'Title of the user registration page',
  },
  pageSubtitle: {
    id: 'features.userRegistration.pageSubtitle',
    defaultMessage: 'Scegli la tipologia di persona che vuoi registrare',
    description: 'Subtitle of the user registration page',
  },
  buttonUserRegistration: {
    id: 'features.userRegistration.buttonUserRegistration',
    defaultMessage: 'Conferma',
    description: 'Label of the user registration button',
  },
  backTo: {
    id: 'features.userRegistration.backTo',
    defaultMessage: 'Torna alla login',
    description: 'Disclaimer "back to login"',
  },
  labelNaturalPersonRadioButton: {
    id: 'features.userRegistration.labelRecoveryUsernameRadioButton',
    defaultMessage: 'Persona fisica',
    description: 'Label of recovery username radio button',
  },
  attemptsNaturalPersonDisclaimer: {
    id: 'features.userRegistration.attemptsNaturalPersonDisclaimer',
    defaultMessage:
      '"Gentile [nome cognome del cliente], benvenuto/a in MyAzimut, il portale riservato ai nostri clienti. Trattandosi del tuo primo accesso, per ragioni di privacy e di sicurezza, ti chiediamo alcuni minuti per configurare correttamente il servizio, inserendo e confermando i dati richiesti a seguire."',
    description: 'attempts NaturalPerson Disclaimer',
  },
  labelLegalPersonRadioButton: {
    id: 'features.userRegistration.labelRecoveryPasswordRadioButton',
    defaultMessage: 'Persona giuridica',
    description: 'Label of recovery password radio button',
  },
  labelFiduciariaRadioButton: {
    id: 'features.userRegistration.labelFiduciariaRadioButton',
    defaultMessage: 'Società fiduciaria',
    description: 'Label of recovery password radio button',
  },
  errorPersonalDataConstraints: {
    id: 'features.userRegistration.errorPersonalDataConstraints',
    defaultMessage:
      'Non è possibile proseguire con la registrazione. Contattare il Servizio Clienti al numero 02.8898.7005, attivo dal Lunedì al Venerdì dalle ore 9:00 alle 18:00. (Costo di una chiamata nazionale tariffata a seconda del profilo del proprio operatore telefonico)',
    description: 'Error message personal data constraints',
  },
  errorUserAlreadyRegistered: {
    id: 'features.userRegistration.errorUserAlreadyRegistered',
    defaultMessage:
      'Non è possibile proseguire con la registrazione, i dati inseriti sono già associati ad un’utenza MyAzimut. Se hai dimenticato le credenziali, clicca su Recupero credenziali per accedere nuovamente',
    description: 'Error message user already registered',
  },
  errorDocumentNotAdmitted: {
    id: 'features.userRegistration.errorDocumentNotAdmitted',
    defaultMessage:
      'Non è possibile proseguire con la registrazione, il documento identificativo depositato non è tra quelli ammessi. Contattare il Servizio Clienti al numero 02.8898.7005, attivo dal Lunedì al Venerdì dalle ore 9:00 alle 18:00. (Costo di una chiamata nazionale tariffata a seconda del profilo del proprio operatore telefonico)',
    description: 'Error message document not admitted',
  },
  errorExpiredDocument: {
    id: 'features.userRegistration.errorExpiredDocument',
    defaultMessage:
      'Non è possibile proseguire con la registrazione, il documento identificativo depositato risulta scaduto. Contattare il Servizio Clienti  al numero 02.8898.7005, attivo dal Lunedì al Venerdì dalle ore 9:00 alle 18:00. (Costo di una chiamata nazionale tariffata a seconda del profilo del proprio operatore telefonico)',
    description: 'Error message expired document',
  },
  errorImpossibleActivation: {
    id: 'features.userRegistration.errorImpossibleActivation',
    defaultMessage:
      'Il Codice Utente risulta non essere stato inserito correttamente. Si prega di controllare.',
    description: 'Error message impossible activation',
  },
  errorUtenteInesistente: {
    id: 'features.userRegistration.errorUtenteInesistente',
    defaultMessage:
      'Il Codice Utente non risulta essere associato a nessun cliente.',
    description: 'Error message impossible activation',
  },
  errorUtenteNonValido: {
    id: 'features.userRegistration.errorUtenteNonValido',
    defaultMessage:
      'Non è possibile proseguire con la registrazione. Contattare il Servizio Clienti al numero 02.8898.7005, attivo dal Lunedì al Venerdì dalle ore 9:00 alle 18:00. (Costo di una chiamata nazionale tariffata a seconda del profilo del proprio operatore telefonico)',
    description: 'Error message user not valid',
  },
  errorCfNonAssociato: {
    id: 'features.userRegistration.errorCfNonAssociato',
    defaultMessage: 'Il codice Fiscale non risulta associata a nessun cliente.',
    description: 'Error message impossible activation',
  },
  errorCfNonAssociatoFiduciaria: {
    id: 'features.userRegistration.errorCfNonAssociatoFiduciaria',
    defaultMessage:
      'Il Codice Fiscale inserito non risulta associato ad una società Fiduciaria.',
    description: 'Error message impossible activation',
  },
  errorPivaNonAssociata: {
    id: 'features.userRegistration.errorPivaNonAssociata',
    defaultMessage:
      'La Partita IVA/Codice Fiscale non risulta associata a nessun cliente.',
    description: 'Error message impossible activation',
  },
  errorInvalidCU: {
    id: 'features.userRegistration.errorInvalidCU',
    defaultMessage:
      'Il Codice Utente risulta non essere stato inserito correttamente. Si prega di controllare.',
    description: 'Error message invalid user code',
  },
  errorInvalidCF: {
    id: 'features.userRegistration.errorInvalidCF',
    defaultMessage:
      'Il Codice fiscale risulta non essere stato inserito correttamente. Si prega di controllare.',
    description: 'Error message invalid fiscal code',
  },
  errorInvalidPI: {
    id: 'features.userRegistration.errorInvalidPI',
    defaultMessage:
      'La Partita IVA / Codice Fiscale risulta non essere stato inserita correttamente. Si prega di controllare.',
    description: 'Error message invalid vat code',
  },
  errorInvalidFI: {
    id: 'features.userRegistration.errorInvalidFI',
    defaultMessage:
      'La Partita IVA risulta non essere stata inserita correttamente. Si prega di controllare.',
    description: 'Error message invalid vat code for fiduciaria',
  },
});
